import { COL_OFFSET } from '@/domain/mitarbeiter/features/rotationsplan/constants';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';

export function getColStartByDate(displayYear: number, date: Date): number {
  const gridStart = dayjs().year(displayYear).isoWeek(1).startOf('isoWeek');

  if (dayjs(date).isBefore(gridStart)) {
    return COL_OFFSET + 1;
  }

  const daysSinceGridStart = dayjs(date).diff(gridStart, 'day');
  return daysSinceGridStart + COL_OFFSET + 1;
}

export function getColEndByDate(displayYear: number, date: Date): number {
  const gridStart = dayjs().year(displayYear).isoWeek(1).startOf('isoWeek');
  const displayDaysOfYear = dayjs().year(displayYear).isoWeeksInYear() * 7;
  const daysSinceGridStart = dayjs(date).diff(gridStart, 'day');

  if (daysSinceGridStart >= displayDaysOfYear) {
    return displayDaysOfYear + COL_OFFSET + 1;
  }

  return daysSinceGridStart + COL_OFFSET + 2;
}
